import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTelegramIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M4.10787 9.4635C4.10787 9.4635 9.64487 7.13143 11.5652 6.31025C12.3013 5.98181 14.7978 4.93069 14.7978 4.93069C14.7978 4.93069 15.95 4.47087 15.854 5.58763C15.822 6.0475 15.5659 7.65694 15.3099 9.39781C14.9258 11.8613 14.5097 14.5547 14.5097 14.5547C14.5097 14.5547 14.4457 15.3102 13.9016 15.4416C13.3575 15.5729 12.4613 14.9817 12.3013 14.8503C12.1733 14.7518 9.9009 13.2737 9.06876 12.5511C8.84471 12.354 8.58868 11.9599 9.10074 11.5C10.253 10.4161 11.6292 9.06937 12.4613 8.21537C12.8454 7.82119 13.2295 6.9015 11.6292 8.01825C9.35681 9.62774 7.11641 11.1387 7.11641 11.1387C7.11641 11.1387 6.60431 11.4671 5.64415 11.1715C4.68394 10.8759 3.56374 10.4817 3.56374 10.4817C3.56374 10.4817 2.79565 9.98906 4.10787 9.4635Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTelegramIcon);
export default ForwardRef;
